var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1542_2021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2804 38.6286C18.1319 38.6286 33.346 23.5394 33.346 15.3033C33.346 7.0671 26.1531 0.390381 17.2804 0.390381C8.40763 0.390381 1.21484 7.0671 1.21484 15.3033C1.21484 23.5394 16.4289 38.6286 17.2804 38.6286ZM17.2804 22.7622C21.7789 22.7622 25.4257 19.377 25.4257 15.2013C25.4257 11.0255 21.7789 7.64044 17.2804 7.64044C12.7819 7.64044 9.13519 11.0255 9.13519 15.2013C9.13519 19.377 12.7819 22.7622 17.2804 22.7622Z",
    fill: "#FFC229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21484 15.3033C1.21484 23.5394 16.4289 38.6286 17.2804 38.6286V22.7622C12.7819 22.762 9.13519 19.377 9.13519 15.2013C9.13519 11.0256 12.7819 7.64046 17.2804 7.64044V0.390381C8.40763 0.390381 1.21484 7.0671 1.21484 15.3033Z",
    fill: "#054FD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1542_2021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8318,
    height: 40,
    fill: "white",
    transform: "translate(0.988281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.96c9418b54e71ec3d45316a9c25c19d8.svg";
export { ForwardRef as ReactComponent };